import { brand } from '@/brand/brand'
import { cn } from '@/lib/utils'

interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const SIZES = {
  sm: 'h-7',
  md: 'h-9',
  lg: 'h-12',
}

export function Logo({ size = 'md', className }: LogoProps) {
  return (
    <img
      src={brand.logoUrl}
      alt={`${brand.company} logo`}
      className={cn('w-auto object-contain', SIZES[size], className)}
      draggable={false}
    />
  )
}

export function LogoWithText({ size = 'md', className }: LogoProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img
        src={brand.logoUrl}
        alt={`${brand.company} logo`}
        className={cn('w-auto object-contain', SIZES[size])}
        draggable={false}
      />
      <span className="text-lg font-semibold tracking-tight">{brand.productName}</span>
    </div>
  )
}
